import PluginFirstBasePNG from './assets/Plugin-FirstBase.png';
import PluginStrikezoneHunterPNG from './assets/Plugin-StrikezoneHunter.png';

import FirstBase1JPG from './assets/FirstBase-1.jpg';
import FirstBase2JPG from './assets/FirstBase-2.jpg';
import FirstBase3JPG from './assets/FirstBase-3.jpg';
import FirstBase4JPG from './assets/FirstBase-4.jpg';
import FirstBase5JPG from './assets/FirstBase-5.jpg';
import FirstBase6JPG from './assets/FirstBase-6.jpg';
import FirstBase7JPG from './assets/FirstBase-7.jpg';

const StrikezoneHunterCommonDescription = [
  `透過 Rebas 好球帶，記錄球速、球種、進壘點等資訊，分析投手投球、打者進攻、甚至捕手配球的各項優劣。`,
  `假使沒有電子好球帶，依然能透過九宮格看出內外高低的配球內容。活用好球帶，發表你/妳最獨到的見解吧！`,
  `訂閱期滿前將寄送 email 提醒續訂，目前沒有自動續訂服務。訂閱期滿後如未續訂，資料仍會保留惟不再開放編輯與球員分析。`,
  `續訂將保留前次訂閱未用完之新增場次額度。`,
];

const StrikezoneHunterCommonRelatedLinks = [
  { name: '好球帶 - Strikezone Hunter', link: `${process.env.REACT_APP_STRIKEZONE_HUNTER_URL}` },
];

const FirstBaseCommonDescription = [
  `球隊可以透過分析賽事，了解球員近期的表現與訓練的成果是否有效反應在實戰當中。亦可依照過往的數據判斷戰術下達時機與球員調度。 服務提供三種主要功能：`,
  `1. 團隊進階數據 - 透過圖表、表格交互呈現數據表現`,
  `2. 球員成長追蹤 - 了解個體球員在每場比賽中的表現，亦可與其他選手相比優劣`,
  `3. 情境模擬分析 - 透過模擬局數、比數、出局數、壘上狀況，評估球員戰術運用能力與心理素質`,
  `分析成果可參考 FirstBase - CPBL 的各隊數據頁面，用 FirstBase 讓你/妳的球隊朝勝利邁進吧！`,
];

const FirstBaseCommonRelatedLinks = [
  { name: 'FirstBase - CPBL', link: `${process.env.REACT_APP_MAINPAGE_URL}/first-base-CPBL` },
];

export const plugins = {
  'strikezone-hunter-monthly': {
    pluginTarget: 'strikezone_hunter',
    pluginName: 'monthly_premium',
    src: PluginStrikezoneHunterPNG,
    alt: 'StrikezoneHunter',
    name: '好球帶-單月',
    price: '899 NT$/月',
    photos: [],
    deposit: false,
    description: [...StrikezoneHunterCommonDescription],
    admonition: [`單月訂閱包含新增最多 8 場比賽之額度上限`],
    relatedLinks: [...StrikezoneHunterCommonRelatedLinks],
  },
  'strikezone-hunter-annual': {
    pluginTarget: 'strikezone_hunter',
    pluginName: 'annual_premium',
    src: PluginStrikezoneHunterPNG,
    alt: 'StrikezoneHunter',
    name: '好球帶-年度',
    price: '10,700 NT$/年',
    photos: [],
    deposit: false,
    description: [...StrikezoneHunterCommonDescription],
    admonition: [`年度訂閱包含新增最多 120 場比賽之額度上限`],
    relatedLinks: [...StrikezoneHunterCommonRelatedLinks],
  },
  'strikezone-hunter-unlimited': {
    pluginTarget: 'strikezone_hunter',
    pluginName: 'annual_unlimited_premium',
    src: PluginStrikezoneHunterPNG,
    alt: 'StrikezoneHunter',
    name: '好球帶-年度無上限',
    price: '19,999 NT$/年',
    photos: [],
    deposit: false,
    description: [...StrikezoneHunterCommonDescription],
    admonition: [
      `此商品無新增比賽額度上限，可於訂閱期間完整使用服務`,
      `此商品訂閱期限無法與 單月、年度 相加，可待原訂閱結束後再購買避免影響權益`,
    ],
    relatedLinks: [...StrikezoneHunterCommonRelatedLinks],
  },
  'strikezone-hunter-analysis': {
    pluginTarget: 'strikezone_hunter',
    pluginName: 'video_analysis',
    src: PluginStrikezoneHunterPNG,
    alt: 'StrikezoneHunter',
    name: '好球帶-影片分析',
    price: '300 NT$/0.5小時',
    photos: [],
    deposit: true,
    description: [...StrikezoneHunterCommonDescription],
    admonition: [
      `本服務需要提供可有效分析的棒球比賽影片（可無電子好球帶），由我方協助分析後上傳至分析平台。依照需求計算實際時間長度，歡迎與我們聯絡了解細節`,
      `單次分析總時數超過 1.5小時，附贈 1 個月訂閱（無新增比賽額度，僅供編輯、分析使用）`,
    ],
    relatedLinks: [...StrikezoneHunterCommonRelatedLinks],
  },

  // 'firstbase-analysis': {
  //   src: PluginFirstBasePNG,
  //   alt: 'FirstBase',
  //   name: '壹壘-紙本紀錄分析',
  //   price: '$500/場',
  //   photos: [FirstBase1JPG, FirstBase2JPG, FirstBase3JPG, FirstBase4JPG, FirstBase5JPG, FirstBase6JPG, FirstBase7JPG],
  //   deposit: true,
  //   description: [...FirstBaseCommonDescription],
  //   admonition: [
  //     `本服務需要提供完整記錄的棒球紀錄單，由我方協助分析後上傳至分析平台。越多場次越能有效分析，歡迎與我們聯絡了解細節`,
  //   ],
  //   relatedLinks: [...FirstBaseCommonRelatedLinks],
  // },
};
